module.exports = __webpack_public_path__ + "img/shoe-prints.40f9e64e.svg";